var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-4" },
    [
      _c("modal-filter", {
        attrs: {
          onfilter: _vm.onfilter,
          filter: _vm.filter,
          exclude: ["state_id", "payment_state_id"],
        },
        on: {
          onclose: function ($event) {
            _vm.onfilter = false
          },
          onfilter: function ($event) {
            return _vm.INIT()
          },
        },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "vstack gap-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column flex-md-row gap-3 justify-content-between",
              },
              [
                _c(
                  "form",
                  {
                    staticClass: "d-flex gap-3 row",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.FILTER()
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.onfilter = true
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-funnel me-2" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Filtro")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "vr opacity-20 mx-3" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-xs text-primary" }, [
                            _vm._v(_vm._s(_vm.count_filter)),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.SORT()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "me-2",
                            class:
                              _vm.filter.sortDesc == "ASC"
                                ? "bi bi-sort-alpha-up"
                                : "bi bi-sort-alpha-down-alt",
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.filter.sortDesc))]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 px-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "input-group input-group-sm input-group-inline",
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.search,
                                expression: "filter.search",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", placeholder: "Buscar..." },
                            domProps: { value: _vm.filter.search },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filter,
                                  "search",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-primary",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm.loading == "table" && _vm.loading_two == "filter"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Buscar")]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.CLEAR()
                            },
                          },
                        },
                        [
                          _vm.loading == "table" && _vm.loading_two == "clear"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Limpiar")]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body p-0" },
                [
                  [
                    _c("v-data-table", {
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.loading == "table" ? [] : _vm.items.data,
                        options: _vm.options,
                        "server-items-length": _vm.items.total,
                        loading: _vm.loading == "table",
                        "footer-props": {
                          "items-per-page-options": [5, 10, 50, 100],
                        },
                      },
                      on: {
                        "update:options": function ($event) {
                          _vm.options = $event
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.id",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(item.type) +
                                    _vm._s(item.id) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.description",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    staticClass: "mx-1",
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              Array.isArray(item.description)
                                                ? _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass: "nowrap",
                                                        },
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.description[0]
                                                          ) +
                                                          " ...\n                                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      _vm._l(
                                        item.description,
                                        function (description, key) {
                                          return _c("div", { key: key }, [
                                            _vm._v(_vm._s(description)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.value",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.value,
                                      expression: "item.value",
                                    },
                                  ],
                                  staticClass: "form-control form-control-sm",
                                  staticStyle: { width: "100px" },
                                  attrs: { type: "text", placeholder: "0.00" },
                                  domProps: { value: item.value },
                                  on: {
                                    keypress: _vm.DOUBLE,
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item,
                                        "value",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "item.category",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("v-select", {
                                  staticClass: "form-control form-control-sm",
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    items: _vm.categories,
                                    "hide-details": "",
                                    dense: "",
                                    value: (item.category = item.category
                                      ? item.category
                                      : "C"),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-select__selection v-select__selection--comma",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(item) +
                                                    "\n                                            "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: item.category,
                                    callback: function ($$v) {
                                      _vm.$set(item, "category", $$v)
                                    },
                                    expression: "item.category",
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "item.files",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                item.files.length < 5
                                  ? _c(
                                      "div",
                                      { staticClass: "d-flex" },
                                      _vm._l(
                                        item.files,
                                        function (file, index) {
                                          return _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-light badge-pill mr-1",
                                            },
                                            [_vm._v(_vm._s(index + 1))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-light badge-pill mr-1",
                                      },
                                      [_vm._v("5+")]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.save",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "button",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "btn btn-success btn-m",
                                                      attrs: {
                                                        disabled: !item.value,
                                                        type: "button",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.SAVE(item)
                                                        },
                                                      },
                                                    },
                                                    "button",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c("small", [
                                                    _c("i", {
                                                      staticClass: "bi bi-save",
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("small", [_vm._v("Guardar y Validar")]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Validos")]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _c("i", { staticClass: "bi bi-search" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Listado")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }